export default __webpack_public_path__ + "static/create-task-236503b69a1f8a6746121affb7618ed3.png";